import {
  NinjaCustomerMappingInput,
  NinjaOneDeviceMappingInput,
  MSPConfiguration,
} from "shared/types/integrations";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";
const BASE_URL = import.meta.env.VITE_APP_INTEGRATION_BASE_URL;

export const getNinjaOneOAuthAuthorization = async (data: {
  url: string;
  frontendUrl: string;
}) => {
  try {
    const url = `${BASE_URL}/auth/ninja/one/${encodeURIComponent(
      data.url
    )}?frontendUrl=${data.frontendUrl}`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw response;
    }
  } catch (error) {
    apiErrorHandler(error as Parameters<typeof apiErrorHandler>[0]);
  }
};

export const getNinjaOneOAuthToken = async (data: { code: string }) => {
  try {
    const url = `${BASE_URL}/token/ninja/one`;
    const response = await axiosClient.post(url, data);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData && response.status === 200) {
      return resData;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export type NinjaPagination = {
  pageSize: number;
  after: number | null;
  hasMore: boolean;
  nextAfter: number | null;
};

export type NinjaPagedResponse<T = Record<string, unknown>> = {
  data: T[];
  pagination: NinjaPagination;
};

export type NinjaOneCustomerRaw = {
  id: number;
  name: string;
  [key: string]: unknown;
};

export type NinjaOneDeviceRaw = {
  id: number;
  systemName?: string;
  organizationId?: number;
  remoteControlUri?: string;
  [key: string]: unknown;
};

export const getNinjaOneCustomers = async ({
  pageSize = 50,
  after,
}: {
  pageSize?: number;
  after?: number;
} = {}): Promise<NinjaPagedResponse<NinjaOneCustomerRaw>> => {
  try {
    let url = `${BASE_URL}/v1/ninja/customers?pageSize=${pageSize}`;
    if (after !== undefined && after !== null) {
      url += `&after=${after}`;
    }
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData && response.status === 200) {
      return {
        data: resData?.data || [],
        pagination: resData?.pagination || {
          pageSize,
          after: null,
          hasMore: false,
          nextAfter: null,
        },
      };
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getNinjaOneDevices = async ({
  pageSize = 50,
  after,
  organizationId,
}: {
  pageSize?: number;
  after?: number;
  organizationId?: number;
} = {}): Promise<NinjaPagedResponse<NinjaOneDeviceRaw>> => {
  try {
    let url = `${BASE_URL}/v1/ninja/devices?pageSize=${pageSize}`;
    if (after !== undefined && after !== null) {
      url += `&after=${after}`;
    }
    if (organizationId !== undefined && organizationId !== null) {
      url += `&organizationId=${organizationId}`;
    }
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData && response.status === 200) {
      return {
        data: resData?.data || [],
        pagination: resData?.pagination || {
          pageSize,
          after: null,
          hasMore: false,
          nextAfter: null,
        },
      };
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const mapNinjaOneCustomers = async ({
  customerData,
  source,
}: NinjaCustomerMappingInput) => {
  try {
    const url = `${BASE_URL}/v1/${source}/mapped-customer`;
    const data = {
      customers: customerData,
    };
    const response = await axiosClient.post(`${url}`, data);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData && response.status === 200) {
      return resData;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const mapNinjaOneDevices = async ({
  deviceMapping,
  source,
}: NinjaOneDeviceMappingInput) => {
  try {
    const url = `${BASE_URL}/v1/ninja/devices/${source}`;
    const data = {
      device_mapping: deviceMapping,
    };
    const response = await axiosClient.post(`${url}`, data);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData && response.status === 200) {
      return resData;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getNinjaMappedCustemers = async (source: string) => {
  try {
    const url = `${BASE_URL}/v1/${source}/mapped-customer`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData && response.status === 200) {
      // const data = NCentralConfigSchema.parse(resData.data);
      return resData?.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getNinjaMappedDevices = async (source: string) => {
  try {
    const url = `${BASE_URL}/v1/ninja/devices/${source}`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData && response.status === 200) {
      // const data = NCentralConfigSchema.parse(resData.data);
      return resData?.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const addNinjaMspConfiguration = async ({
  board,
}: {
  board: MSPConfiguration;
}) => {
  try {
    const url = `${BASE_URL}/ninja/msp/configuration`;
    const data = {
      board,
    };
    const response = await axiosClient.post(`${url}`, data);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData && response.status === 200) {
      return resData;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getNinjaMspConfiguration = async () => {
  try {
    const url = `${BASE_URL}/ninja/msp/configuration?frontendUrl=${window.location.origin}`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData && resData.statusCode === 304 && resData.data?.redirect_url) {
      window.location.href = resData.data.redirect_url;
      throw new Error(resData?.message);
    }
    if (resData && resData.statusCode === 200) {
      return resData;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};
